import { LoadableLazy } from '@confluence/loadable';

export const ConnectEOSPopup = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectEOSPopup" */ './ConnectEOSPopup.jsx'))
			.ConnectEOSPopup,
});
